<template>

  <el-form
    size="mini"
    label-position="left"
    label-width="100px"
  >
    <el-form-item label="Название">
      <div style="display: flex">
        <click-to-edit
          style="width: 100%"
          v-model="template.name"
          @input="saveScaleTemplate(template)"
        ></click-to-edit>
        <div style="margin-left:10px;width: 100px">ID: {{ template.id }}</div>
        <el-popconfirm
          confirm-button-text='Да'
          cancel-button-text='Нет'
          icon="el-icon-question"
          title="Вы уверены, что хотите удалить шаблон?"
          @confirm="deleteScaleTemplate(template)"
        >
          <el-button
            slot="reference"
            size="small"
            icon="fas fa-trash"
          >

          </el-button>

        </el-popconfirm>
      </div>
    </el-form-item>

    <el-form-item label="Критерии">
      <el-table-draggable handle=".scope-grab" @drop="scaleTemplateScopeOrderChanged(template, $event)">
        <el-table
          size="mini"
          empty-text="Нет критериев"
          :data="template.scopes"
        >
          <el-table-column width="30" v-slot="scope">
            <i class="fas fa-arrows-alt-v scope-grab"></i>
          </el-table-column>
          <el-table-column label="Подпись" v-slot="scope">
            <click-to-edit
              v-model="scope.row.name"
              placeholder=""
              style="width: 100%"
              @input="updateScaleTemplateScope(template, scope.row)"
            ></click-to-edit>
          </el-table-column>
          <el-table-column width="120" label="Значение">
            <template v-slot="scope">
              <click-to-edit
                v-model="scope.row.value"
                placeholder=""
                style="width: 100%"
                digits-only
                @input="updateScaleTemplateScope(template, scope.row)"
              ></click-to-edit>
            </template>
          </el-table-column>
          <el-table-column width="110" align="right">
            <template slot="header" slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                icon="fas fa-plus"
                @click="createScaleTemplateScope(template)"
              >
                Добавить
              </el-button>
            </template>
            <template slot-scope="scope">
              <el-popconfirm
                confirm-button-text='Да'
                cancel-button-text='Нет'
                icon="el-icon-question"
                title="Вы уверены, что хотите удалить критерий?"
                @confirm="deleteScaleTemplateScope(template, scope.row)"
              >
                <el-button
                  slot="reference"
                  class="table-action-button"
                  size="mini"
                  round
                  icon="far fa-trash-alt"
                >
                </el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-table-draggable>
    </el-form-item>


  </el-form>

</template>

<script>

import {off, on} from "element-ui/src/utils/dom";
import requestSender from "@/api/base/requestSender";
import ClickToEdit from "@/components/ClickToEdit.vue";
import ScaleTemplate from "@/components/configurableScales/settings/ScaleTemplate.vue";
import ElTableDraggable from "element-ui-el-table-draggable";
import CardCreateTemplates from "@/components/cards/CardCreateTemplates.vue";

export default {
  name: "CascadingQualityScaleEditForm",
  components: {CardCreateTemplates, ScaleTemplate, ClickToEdit, ElTableDraggable},
  props: {
    template: {type: Object, required: true},
  },

  data() {
    return {
      loading: false,
    }
  },
  methods: {

    saveScaleTemplate(template) {
      this.loading = true;
      this.$api.cascading.updateQualityScaleTemplate({
        id: template.id,
        name: template.name,
      })
        .finally(() => {
          this.loading = false;
        })
    },

    deleteScaleTemplate(template) {
      this.loading = true;
      this.$api.cascading.deleteQualityScaleTemplate({
        id: template.id,
      })
        .finally(() => {
          this.$emit('deleted', this.template);
        })
    },


    createScaleTemplateScope(template) {
      this.loading = true;
      this.$api.cascading.createQualityScaleTemplateScope({
        scale_id: template.id,
      })
        .then(data => {
          this.$set(template, 'scopes', data.scale.scopes);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    updateScaleTemplateScope(template, scope) {
      this.loading = true;
      this.$api.cascading.updateQualityScaleTemplateScope({
        id: scope.id,
        order: scope.order,
        name: scope.name,
        value: scope.value,
      })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteScaleTemplateScope(template, scope) {
      this.loading = true;
      this.$api.cascading.deleteQualityScaleTemplateScope({
        id: scope.id,
        name: scope.name,
        value: scope.value,
      })
        .then(data => {
          this.$set(template, 'scopes', data.scale.scopes);
        })
        .finally(() => {
          this.loading = false;
        })
    },


    scaleTemplateScopeOrderChanged(template, event) {
      const newPositionIndex = event.list.map(e => e.id).indexOf(event.targetObject.id);
      event.targetObject.order = newPositionIndex + 1;

      this.updateScaleTemplateScope(template, event.targetObject);
    }


  },


}
</script>

<style lang="scss" scoped>
.scope-grab {
  padding: 0 7px;
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.scope-grab:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
</style>